import { getAuthToken } from "./../../../Utils/authToken";
import { getStoreId } from "../../../Utils/common";
import Config from "../../../Config";
import { INITIAL_ROUTE_FOR_WEBVIEW_DASHY } from "../../../Utils/constants";
import history from "../../../Utils/history";

const urlParams = new URLSearchParams(window.location.search);
const app_version = urlParams.get("app_version");
const app_version_code = urlParams.get("app_version_code");
const upi_options = urlParams.get("upi_options");

export interface RouteObj {
  url: string;
  digitalDukaanRoute?: string;
  additionalParamString?: string;
}

export function getDigitalDukaanWebviewLink(url: string, additionalParamString = "") {
  const routeAppender = url?.includes("?") ? "&" : "?";
  const webviewLink = `${Config.webviewURL}${url}${routeAppender}storeid=${getStoreId()}&token=${getAuthToken()}&app_version=${app_version}&app_version_code=${app_version_code}${additionalParamString}&prevUrl=${encodeURIComponent(window.location.href)}&upi_options=${upi_options}`;
  window.open(webviewLink, "_self");
}

export function getRoutingLink(route: RouteObj) {
  const isDashy = !location.pathname.includes("webview");
  const additionParams = route.additionalParamString || "";

  if (route?.digitalDukaanRoute && !isDashy) {
    getDigitalDukaanWebviewLink(route?.digitalDukaanRoute, additionParams);
    return;
  }

  const routeAppender = route?.url?.includes("?") ? "" : "?";

  return isDashy
    ? history.push(route?.url + routeAppender + additionParams)
    : history.push(
        `${INITIAL_ROUTE_FOR_WEBVIEW_DASHY}${route?.url}?storeid=${getStoreId()}&token=${getAuthToken()}&app_version=${app_version}&app_version_code=${app_version_code}${additionParams}&upi_options=${upi_options}`,
      );
}
